module.exports = __webpack_public_path__ + "img/ideal.4eddc5e.svg";